<template lang="html">
<div>
  <Form :inline="true" class="form-default">
    <FormItem  v-for="(customField,index) in customFields"
      :key="index"
      :label="customField.label"
    >
      <Input
        v-if="customField.type === FIELD_TYPES.TEXTBOX"
        :placeholder="`Enter ${customField.label} here`"
        type="text"
        v-model="customFieldValues[customField.name]">
      </Input>
      <DatePicker
        v-if="customField.type === FIELD_TYPES.DATE"
        type="datetime"
        format="dd-MM-yyyy hh:mmA"
        v-model="customFieldValues[customField.name]"
        :placeholder="$t('INDENT_ENTER_DATE')"
      >
      </DatePicker>
    </FormItem>
  </Form>
  <div class="popover-footer pt-0 mt-15">
    <Button type="primary" size="mini" @click="emptyContainerReturned()">
      {{$t('INDENT_SUBMIT')}}
    </Button>
  </div>
  </div>
</template>
<script>
import { FIELD_TYPES } from 'pando-constants';
import Attachments from '@common/components/Attachments';

export default {
  props: ['order', 'getBackDateConfig', 'eximCustomFields'],
  components: {
    Attachments,
  },
  data() {
    return {
      customFieldValues: {},
      FIELD_TYPES,
    };
  },

  computed: {
    customFields() {
      let response = [];
      if (this.order && this.order.exim_type && this.$hasFeature('exim_enabled')) {
        response = this.eximCustomFields && this.eximCustomFields.empty_container_fields;
      }
      return response;
    },
  },

  methods: {
    async emptyContainerReturned() {
      try {
        const { order_number: id } = this.order;
        const data = {};
        Object.keys(this.customFieldValues).forEach((customFieldKey) => {
          data[customFieldKey] = this.customFieldValues[customFieldKey];
        });
        const result = await this.$store.dispatch('order/emptyContainerReturned', {
          id,
          data,
        });
        if (result.order_number) {
          this.$success({
            message: this.$t('INDENT_EMPTY_CTR_RETURN_SUCCESS_MSG', { order_number: result.order_number }),
          });
        } else {
          this.$error({
            message: this.$t('INDENT_EMPTY_CTR_RETURN_ERROR_MSG'),
          });
        }
      } catch (error) {
        this.$error({
          message: this.$t('INDENT_EMPTY_CTR_RETURN_ERROR_MSG'),
        });
      }
    },
  },
};
</script>
